import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import securityOptions from "@/store/securityOptions";

const BASE_URL = "https://cdtes-api.chedroxi.com/api";
// const BASE_URL = "http://localhost:8000/api";


const ls = new SecureLS(securityOptions);
let Store;

Vue.use(Vuex);

try {
  Store = new Vuex.Store({
    state: {
      BASE_URL_ALTERNATE: "https://cdtes-api.chedroxi.com",
      // BASE_URL_ALTERNATE: "http://localhost:8000",
  
      Sidebar_drawer: true,
      Customizer_drawer: false,
      SidebarColor: "white", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
      SidebarBg: "",
      ThemeColor: "#0D47A1",
      internalValue: false,
      navbarColor: "primary",
      setHorizontalLayout: false, // Horizontal layout
  
      user: [],
      user_profile: {},
      loading: false,
      is_authenticated: false,
      total_payroll: 0,
      token: [],
      filters: null,
      update_notice: false,
      profile_update_notice: true,
    },
    mutations: {
      SET_SIDEBAR_DRAWER(state, payload) {
        state.Sidebar_drawer = payload;
      },
      SET_CUSTOMIZER_DRAWER(state, payload) {
        state.Customizer_drawer = payload;
      },
      SET_SIDEBAR_COLOR(state, payload) {
        state.SidebarColor = payload;
      },
      SET_NAVBAR_COLOR(state, payload) {
        state.navbarColor = payload;
      },
      SET_LAYOUT(state, payload) {
        state.setHorizontalLayout = payload;
      },
      SET_SIDEBAR_LAYOUT(state, payload) {
        state.internalValue = payload;
      },
      SET_UPDATE_NOTICE(state, payload) {
        state.update_notice = payload;
      },
      SET_PROFILE_UPDATE_NOTICE(state, payload) {
        state.profile_update_notice = payload;
      },
      isLoading(state, payload){
        state.loading = payload
      },
      isAuthenticated(state, payload){
        state.is_authenticated = payload;
      },
      setToken(state, payload){
        state.token = payload;
      },
      setUser(state, payload){
        state.user = payload;
      },
      setUserProfile(state, payload){
        state.user_profile = payload;
      },
      setRequestHeader(state, payload){
        axios.defaults.headers.common["Authorization"] = `Bearer ${payload}`;
      },
      clearCredentials(state){
        state.filters = null;
        state.user = [];
        state.token = [];
        state.user_profile = {};
        state.is_authenticated = false;
        setTimeout(() => {
          state.update_notice = false;
          state.profile_update_notice = true;
        }, 2000);
      },
      setTotalNumberOfPayroll(state, payload){
        state.total_payroll = payload;
      },
      setFilters(state, payload){
        state.filters = payload.data;
      },
      clearFilters(state){
        state.filters = null;
      },
      setDocumentTypes(state, payload){
        state.filters.documents.unshift(payload);
      },
  
      setDocumentTags(state, payload){
        state.filters.document_tags.unshift(payload);
      },
  
      setInstitutions(state,payload){
        state.filters.institutions.unshift(payload);
      }
    },
    actions: {
      /**
       * Login and Logout
       */
       signIn(context, payload){
        context.commit('isLoading', true);
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            axios.post(`${BASE_URL}/user/auth/signin`, payload)
            .then((response) => {
              context.commit('isLoading', false);
              context.commit('isAuthenticated', true);
              context.commit('setToken', response.data);
              resolve(response);
            })
            .catch((error) => {
              context.commit('isLoading', false);
              context.commit('isAuthenticated', false);
              reject(error);
            })
          }, 1000)
        })
      },
  
      async signingIn({dispatch, commit, getters },payload){
        await dispatch('signIn', payload);
      },
      
      signOut({commit, getters}){
        return new Promise((resolve, reject) => {
          commit("isLoading", true);
          axios.post(`${BASE_URL}/user/auth/sign-out`, null , { headers: {"Authorization" : `Bearer ${getters.token.access_token}`}})
          .then((response) => {
            commit('clearCredentials');
            commit("isLoading", false);
            resolve(response);
          })
          .catch((error) => {
            commit('clearCredentials');
            commit("isLoading", false);
            reject(error);
          });
        })
      },
  
      /**
       * Login and Logout Ends
       */
  
  
      
      /** Getting Transaction Starts*/
      
      getAllTransactions(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/home`, { params : payload })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      getAllAssignedTransactions(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/assign_transactions/get`, { params : payload })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
  
      getAllArchivedTransactions(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/app/transaction/archived/get/all`, { params : payload })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      getSelectedTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/app/transaction/edit/` + payload.id)
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
      /** Getting Transaction Ends*/
  
  
      /** Transaction Logs */
      getTransactionActivityTimeline(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/transaction/timeline/` + payload.id)
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
      /**Transaction Logs Ends */
  
      /** Creating Transaction */
      createTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/transaction/create`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /**Creating Transaction Ends */
  
      /** Saving Created Transaction Starts */
      saveTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          let formData = new FormData();
          payload.selected_files.forEach(file => {
            formData.append('files[]', file);
          });
  
          formData.append('control_id', payload.control_id);
          formData.append('from', payload.from);
          formData.append('date_receive', payload.date_receive);
          formData.append('document_type', payload.document_type);
          formData.append('related_to[]', payload.related_to);
          formData.append('assignee', payload.assignee);
          formData.append('status', payload.status);
          formData.append('priority_level', payload.priority_level);
          formData.append('submission_type', payload.submission_type);
          formData.append('subject', payload.subject);
          formData.append('comments', payload.comments);
          formData.append('transaction_type', payload.transaction_type);
          axios.post(`${BASE_URL}/app/transaction/store`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Saving Created Transaction Ends */
  
      /** Saving Created Transaction Starts */
      updateTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          let formData = new FormData();
          formData.append('file', payload.attachments);
          formData.append('control_id', payload.control_id);
          formData.append('from', payload.from);
          formData.append('date_receive', payload.date_receive);
          formData.append('document_type', payload.document_type);
          formData.append('related_to[]', payload.related_to);
          formData.append('assignee', payload.assignee);
          formData.append('status', payload.status);
          formData.append('priority_level', payload.priority_level);
          formData.append('submission_type', payload.submission_type);
          formData.append('subject', payload.subject);
          formData.append('comments', payload.comments);
          formData.append('attachments', payload.attachments);
          formData.append('transaction_type', payload.transaction_type);
          axios.post(`${BASE_URL}/app/transaction/update/${payload.id}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Saving Created Transaction Ends */
  
  
  
      deleteTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.delete(`${BASE_URL}/app/transaction/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      
      /** Transfer Transaction Starts */
      transferTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          let formData = new FormData();
          payload.selected_files.forEach(file => {
            formData.append('files[]', file);
          });
          formData.append('id', payload.id);
          formData.append('assignee', payload.assignee);
          formData.append('status', payload.status);
          formData.append('priority_level', payload.priority_level);
          formData.append('comments', payload.comments);
          formData.append('outgoing', payload.outgoing);
          axios.post(`${BASE_URL}/app/transaction/transfer`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Transfer Transaction Ends */
  
      /** Transfer from monitoring Transaction Starts */
      transferTransactionFromMonitoring(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          let formData = new FormData();
          payload.selected_files.forEach(file => {
            formData.append('files[]', file);
          });
          formData.append('id', payload.id);
          formData.append('assignee', payload.assignee);
          formData.append('status', payload.status);
          formData.append('priority_level', payload.priority_level);
          formData.append('comments', payload.comments);
          formData.append('outgoing', payload.outgoing);
          formData.append('component', 'monitoring');
          axios.post(`${BASE_URL}/app/transaction/transfer`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Transfer from monitoring Transaction Ends */
  
  
      /** Release Transaction Starts */
      releaseTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          let formData = new FormData();
          payload.selected_files.forEach(file => {
            formData.append('files[]', file);
          });
          formData.append('id', payload.id);
          formData.append('tracking_number', payload.tracking_number);
          formData.append('released_through', payload.released_through);
          formData.append('remarks', payload.remarks);
          formData.append('receiver', payload.receiver);
          formData.append('link', payload.link);
          
          axios.post(`${BASE_URL}/app/transaction/release`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Release Transaction Ends */
  
  
      /** Archiving Transaction Starts */
      archiveTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/transaction/archive/${payload.transaction_id}`, null, { params: payload })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Arching Transaction Ends */
  
      /** UnArchiving Transaction Starts */
      unArchiveTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/transaction/unarchive/${payload.transaction_id}`, null, { params: payload })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** UnArching Transaction Ends */
  
      /** Bulk Archiving Transaction Starts */
      bulkArchiveTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          let formData = new FormData();
          payload.transactions.forEach(item => {
            formData.append('transactions[]', JSON.stringify(item));
          });
          formData.append('archive_date', payload.archive_date);
          formData.append('status', payload.status);
          formData.append('remarks', payload.remarks);
          axios.post(`${BASE_URL}/app/transaction/archive/bulk/trasactions`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Bulk Arching Transaction Ends */
  
      /** Bulk Archiving Transaction Starts */
      bulkUnArchiveTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          let formData = new FormData();
          payload.transactions.forEach(item => {
            formData.append('transactions[]', JSON.stringify(item));
          });
          axios.post(`${BASE_URL}/app/transaction/unarchive/bulk/trasactions`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Bulk Arching Transaction Ends */
  
  
      /** Bulk Transfer Transaction Starts */
      transferBulkTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          let formData = new FormData();
          payload.selected_files.forEach(file => {
            formData.append('files[]', file);
          });
  
          payload.transactions.forEach(item => {
            formData.append('transactions[]', JSON.stringify(item));
          });
          formData.append('id', payload.id);
          formData.append('assignee', payload.assignee);
          formData.append('status', payload.status);
          formData.append('priority_level', payload.priority_level);
          formData.append('comments', payload.comments);
          axios.post(`${BASE_URL}/app/transaction/transfer/bulk`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Bulk Transfer Transaction Ends */
  
  
      /** User Functionalities Starts */
  
      getAllUsers(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/app/transaction/user`, { params : payload })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
  
      /** User Functionalities Ends */
  
  
      /** Account Profile */
      getAccountProfile(context){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/user/auth/get`)
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      updateAccountProfile(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.post(`${BASE_URL}/app/user/account/profile/update`, null, { params: payload })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      updateAccountPassword(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.post(`${BASE_URL}/app/user/profile/password/update`, null, {params: payload})
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      updateAccountProfilePhoto(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          let formData = new FormData();
          formData.append('photo', payload);
          axios.post(`${BASE_URL}/app/user/profile/photo/update`, formData , {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
      
      /** Account Profile Ends */
      
      /** Dashboard */
      getDashboardStats(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/app/transaction/dashboard/data/get`, { params : { data_to_render: payload.data_to_render } })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      getBarGraphData(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/app/transaction/dashboard/bar_graph/transactions_chart/get`, { params : payload.filters })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      getPieData(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/app/transaction/dashboard/pie_chart/transactions_chart/get`)
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
      /**Dashboard Ends */
  
      /** Activity Timeline */
      deleteActivity(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.delete(`${BASE_URL}/app/payroll/dashboard/activity/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      /** Activity Timeline Ends */
  
      /** User Notifications */
      getNotifications(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/app/notifications/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      markNotificationAsRead(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/notifications/mark/read`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      markAllNotificationsAsRead(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/notifications/mark/all/read`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      deleteNotification(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/notifications/delete`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      /** User Notifications Ends */
  
  
      /** Comment Functionalities */
      saveComment(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/transaction/comment/store`, null, {
            params: {
              comment: payload.comment,
              control_id: payload.control_id
            }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      deleteComment(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.delete(`${BASE_URL}/app/transaction/comment/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      /** End Comment Functionalities */
  
  
      /** Important Links Functionalities */
      saveLink(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/transaction/link/store`, null, {
            params: {
              link: payload.link,
              transaction_id: payload.id
            }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      deleteLink(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.delete(`${BASE_URL}/app/transaction/link/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      /** Ends Important Links Functionalities */
  
  
      /** Uploading Attachment Starts */
      uploadAttachments(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          let formData = new FormData();
          payload.selected_files.forEach(file => {
            formData.append('files[]', file);
          });
          formData.append('control_id', payload.control_id);
          
          axios.post(`${BASE_URL}/app/transaction/attachment/store`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Uploading Attachment Starts Ends */
  
      /** Deleting Attachment Starts */
      deleteAttachment(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.delete(`${BASE_URL}/app/transaction/attachment/delete/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      /** Deleting Attachment Ends */
  
  
      /** Adding Document Tags/Related To */
      saveNewDocumentTag(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/transaction/document_tags/store`, null, { params: { name: payload } })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Adding Document Tags/Related To Ends */
  
      /** Adding New Sender/Institution */
      saveNewSender(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/transaction/new_sender/store`, null, { params: { name: payload } })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Adding New Sender/Institution Ends */
  
      /** Adding New Sender/Institution */
      saveDocumentType(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/transaction/new_document_type/store`, null, { params: { name: payload } })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Adding New Sender/Institution Ends */
  
  
      /** Form Fillers Starts */
      getFormFillers(context, payload){
        context.commit('clearFilters');
  
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/app/transaction/form_fillers/get`)
          .then((response) => {
            context.commit("setFilters", response);
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      getFormFillersForReleasing(context, payload){
        if(!context.state.filters || payload.reload){
          if(payload.reload){
            context.commit('clearFilters');
          }
  
          context.commit('setRequestHeader', context.getters.token.access_token);
          return new Promise ((resolve, reject) => {
            context.commit("isLoading", true);
            axios.get(`${BASE_URL}/form_fillers/receiving/get`)
            .then((response) => {
              context.commit("setFilters", response);
              context.commit("isLoading", false);
              resolve(response);
            })
            .catch((error)=>{
              context.commit("isLoading", false);
              reject(error);
            });
          });
        }
        
      },
      /**Form Fillers Ends */
  
  
      /** Releasing Starts */
      getForReleaseTransactions(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/releasing/index`, { params : payload })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      getReceivedTransactions(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          context.commit("isLoading", true);
          axios.get(`${BASE_URL}/releasing/received/index`, { params : payload })
          .then((response) => {
            context.commit("isLoading", false);
            resolve(response);
          })
          .catch((error)=>{
            context.commit("isLoading", false);
            reject(error);
          });
        });
      },
  
      getReceiversList(context, payload){
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/receivers/get`, { params: payload })
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      saveNewReceiver(context, payload){
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/receiver/store`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      receiveTransaction(context, payload){
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/releasing/receive/transaction`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      receiveBulkTransactions(context, payload){
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/releasing/receive/bulk_transactions`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      /** UnArchiving Transaction Starts */
      unReleaseTransaction(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/transaction/unrelease/${payload.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** UnArching Transaction Ends */
      /** Releasing Ends */
  
      /** Personal Info Functions  */
      updatePersonalInfo(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/user/profile/personal_info/update`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      /** Personal Infor */
  
      /** Employment Info Functions  */
      updateEmploymentInfo(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/user/profile/employment_info/update`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Employment Infor */
  
      /** Address Info Functions  */
      updateAddressInfo(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/user/profile/address_info/update`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Address Info */
  
  
      /** OTP Functions */
      submitNewEmailForm(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/OTP/mail/send`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
  
      validateOTP(context, payload){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.post(`${BASE_URL}/app/OTP/mail/validate`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** OTP Functions Ends */
  
      /** Session Token Validator */
      validateSessionToken(context){
        context.commit('setRequestHeader', context.getters.token.access_token);
        return new Promise ((resolve, reject) => {
          axios.get(`${BASE_URL}/user/auth/get`)
          .then((response) => {
            resolve(response);
          })
          .catch((error)=>{
            reject(error);
          });
        });
      },
      /** Session Token Validator Ends */
    },
    getters: {
      BASE_URL_ALTERNATE(state){
        return state.BASE_URL_ALTERNATE;
      },
      GET_UPDATE_NOTICE(state){
        return state.update_notice;
      },
      GET_PROFILE_UPDATE_NOTICE(state){
        return state.profile_update_notice;
      },
      isLoading(state) {
        return state.loading;
      },
      isAuthenticated(state){
        return state.is_authenticated;
      },
      token(state){
        return state.token;
      },
      getUser(state){
        return state.user;
      },
      getUserProfile(state){
        return state.user_profile;
      },
      getTotalNumberOfPayroll(state){
        return state.total_payroll;
      },
      getUserRoles(state){
        return state.user_profile.roles;
      },
      getFilters(state){
        return state.filters;
      }
    },
  
    plugins: [
      createPersistedState({
        storage: {
          getItem: key => ls.get(key),
          setItem: (key, value) => ls.set(key, value),
          removeItem: key => ls.remove(key)
        }
      })
    ]
  });
} catch (error) {
  window.localStorage.clear();
}

export default Store;